import PropTypes from 'prop-types';
import React from 'react';
import Button from '../../../../core/modules/common/components/Button';
import themeStyles from '../../../../materialUiTheme';
import HeaderTile from './HeaderTile';
import scDefinitons from '../../../common/config/SelectionCriteriaDefinitions';

const SelectionCriteriaHeader = (props) => {
  const {
    canGenerateReport = false,
    canFetchReport = true,
    isReportPage = false,
    selectedValues,
    report,
    routes,
    onGenerateClick,
    emailClick,
  } = props;

  return (
    <div className="wizard-header">

      {report.selectionCriteria.items.map(sc => (
        <HeaderTile
          key={sc}
          linkTo={routes[scDefinitons[sc].routeName]}
          title={scDefinitons[sc].title}
          value={selectedValues[sc]}
          icon={scDefinitons[sc].icon}
          showSelectedValue={scDefinitons[sc].showSelectedValue}
          reportName={report.id}
        />
      ))}

      {isReportPage === false &&
        <div className="wizard-header__call-to-action">
          {!canFetchReport ?
            <Button
              style={canGenerateReport ? themeStyles.blueButton : {}}
              text="app.wizard.button.back-to-report"
              onClick={onGenerateClick}
              disabled={!canGenerateReport}
            /> :
            <div style={{ display: 'flex' }}>
              <span className="generate-report-title">
                Generate report:
              </span>
              <div>
                {!report.emailOnly && (
                  <Button
                    className="generate-on-screen-button"
                    style={canGenerateReport ? themeStyles.blueButton : {}}
                    text="app.button.generate.on-screen.button"
                    onClick={onGenerateClick}
                  />
                )}
                <Button
                  className="generate-email-button"
                  style={canGenerateReport ? themeStyles.blueButton : {}}
                  text="app.button.generate.email.button"
                  onClick={emailClick}
                />
              </div>
            </div>
          }
        </div>
      }
    </div>
  );
};

export default SelectionCriteriaHeader;

SelectionCriteriaHeader.propTypes = {
  report: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    selectionCriteria: PropTypes.objectOf(PropTypes.shape),
    emailOnly: PropTypes.bool,
  }),
  routes: PropTypes.objectOf(PropTypes.shape).isRequired,
  canGenerateReport: PropTypes.bool,
  canFetchReport: PropTypes.bool,
  isReportPage: PropTypes.bool,
  selectedValues: PropTypes.objectOf(PropTypes.shape),
  onGenerateClick: PropTypes.func,
  emailClick: PropTypes.func,
};
